// extracted by mini-css-extract-plugin
module.exports = {"box":"style_box__N_51z","loading":"style_loading__9cjG2","prose":"style_prose__zjXlM"};